import { NordEvent } from '../common/events.js'

/**
 * Dispatched when the user chooses the "Create" affordance in a `creatable`
 * combobox. Carries the current search query. By default the combobox then adds
 * the value as an option and selects it; the event is cancelable, so calling
 * `preventDefault()` opts out and lets the consumer handle creation manually.
 */
export class ComboboxCreateEvent extends NordEvent {
  static eventName = 'create'

  constructor(
    /** The search query the user typed, offered as the new option's label. */
    public readonly value: string,
  ) {
    super(ComboboxCreateEvent.eventName, { cancelable: true })
  }

  /** Convenience accessor mirroring `CustomEvent.detail`. */
  get detail() {
    return this.value
  }
}

/**
 * Dispatched when the value is cleared via the clear button or the `clear()`
 * method, before the accompanying `change` event.
 */
export class ComboboxClearEvent extends NordEvent {
  static eventName = 'clear'

  constructor() {
    super(ComboboxClearEvent.eventName)
  }
}
